// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__ySTui","dashboard":"Dashboard_dashboard__lk7du","columns":"Dashboard_columns__RlpKf","main":"Dashboard_main__faPGr","side":"Dashboard_side__qCgWa"};